import { render, staticRenderFns } from "./ManutencaoCatalogoServico.vue?vue&type=template&id=3c6ec7aa&scoped=true&"
import script from "./ManutencaoCatalogoServico.vue?vue&type=script&lang=js&"
export * from "./ManutencaoCatalogoServico.vue?vue&type=script&lang=js&"
import style0 from "./ManutencaoCatalogoServico.vue?vue&type=style&index=0&id=3c6ec7aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6ec7aa",
  null
  
)

export default component.exports